<template>
  <v-container>
  <v-flex>
    <v-card class="elevation-1">
      <v-toolbar color="primary">
        <v-toolbar-title class="white--text">Issued Policies</v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12 lg2>
            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 lg2 class="pt-4 pl-3">
              <v-menu
                  lazy
                  :close-on-content-click="false"
                  v-model="menuFrom"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="Date from:"
                    v-model="dateFrom"
                    prepend-icon="event"
                  ></v-text-field>
                  <v-date-picker v-model="dateFrom" @input="dateFormatted = formatDate($event)" no-title scrollable actions>
                    <template slot-scope="{ save, cancel }">
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                        <v-btn flat color="primary" @click="save">OK</v-btn>
                      </v-card-actions>
                    </template>
                  </v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs12 lg2 class="pt-4 pl-3">
              <v-menu
                lazy
                :close-on-content-click="false"
                v-model="menuTo"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="Date to:"
                  v-model="dateTo"
                  prepend-icon="event"
                ></v-text-field>
                <v-date-picker v-model="dateTo" no-title scrollable actions>
                  <template slot-scope="{ save, cancel }">
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="cancel">Cancel</v-btn>
                      <v-btn flat color="primary" @click="save">OK</v-btn>
                    </v-card-actions>
                  </template>
                </v-date-picker>
              </v-menu>
            </v-flex>
          <v-flex xs12 lg1 class="pt-2 pl-5">
            <v-btn color="primary" @click="getPolicies" dark right block> Search
            </v-btn>
          </v-flex>
      </v-card-title>
      <v-flex>
        <v-data-table
            :headers="headers"
            :items="items"
            :pagination.sync="pagination"
            :search="search"
            :loading="loading"
            :rows-per-page-items="rows"
            item-key="uuid"
          >
          <template slot="items" slot-scope="props">
            <tr v-bind:style="{ cursor: props.item.people.length > 1 ? 'pointer' : 'auto' }" @click=" props.item.insurance_type !== 'Single' ? props.expanded = !props.expanded : null">
              <td class="text-xs-center">{{ props.item.uuid }}</td>
              <td class="text-xs-center">{{ props.item.created_at | removeTime}}</td>
              <td class="text-xs-center">{{ props.item.insurance_type}}</td>
              <td class="text-xs-center">{{ props.item.beneficiary.first_name + ' ' + props.item.beneficiary.middle_name + ' ' + props.item.beneficiary.last_name }}</td>
              <td class="text-xs-center">{{ props.item.beneficiary.passport_number }}</td>
              <td class="text-xs-center">{{ props.item.country_residence}}</td>
              <td class="text-xs-center">{{ props.item.country_destination}}</td>
              <td class="text-xs-center">{{ props.item.duration_from}}</td>
              <td class="text-xs-center">{{ props.item.duration_to}}</td>
              <td class="text-xs-center red--text" v-if="props.item.cancelled === '1'">{{ props.item.cancelled | booleanify}}</td>
              <td class="text-xs-center green--text" v-else>{{ props.item.cancelled | booleanify}}</td>
              <td>
                <v-layout align-center>
                  <v-flex>
                    <v-btn
                      @click="showPolicy(props.item)" 
                      small 
                      dark color="primary"
                      >
                      show
                      </v-btn>
                  </v-flex>
                </v-layout>
              </td>
            </tr>
          </template>
          <template slot="expand" slot-scope="props">
            <v-list three-line v-for="(person, index) in props.item.people" :key="index" class="grey lighten-4">
              <v-subheader class="headline" v-if="index === 0" > Beneficiary</v-subheader>
              <v-subheader class="headline" v-if="props.item.total_parents > 1 && index == 1"> Spouse</v-subheader>
              <v-subheader class="headline" v-if="props.item.total_children && (props.item.total_parents == 1 && index !== 0)"> Child {{ index }}</v-subheader>
              <v-subheader class="headline" v-if="props.item.total_children && (props.item.total_parents == 2 && index !== 0 && index !== 1)"> Child {{ index - 1 }}</v-subheader>
              <v-subheader class="headline" v-if="!props.item.total_children && !props.item.total_parents && index != 0"> User {{ index }}</v-subheader>
                <v-list-tile two-line>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ person.first_name + ' ' + person.middle_name + ' ' + person.last_name }}</v-list-tile-title>
                    <v-list-tile-sub-title>Name</v-list-tile-sub-title>
                    <v-list-tile-title>{{ person.passport_number }}</v-list-tile-title>
                    <v-list-tile-sub-title>Passport number</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
            </v-list>
          </template>
          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            Showing {{ pageStart }} to {{ pageStop }} Total: {{ items.length}}
          </template>
        </v-data-table>
      </v-flex>
    </v-card>
  </v-flex>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment"
export default {
  data() {
    return {
      loading: true,
      search: "",
      dateFrom: moment().subtract(1, 'month').format("YYYY-MM-DD"),
      menuFrom: null,
      dateTo: null,
      menuTo: null,
      rows: [10, 15, 25, { text: "All", value: -1 }],
      searchQuery: '',
      pagination: {},
      headers: [
        {
          text: "ID",
          align: "center",
          sortable: false,
          value: "uuid"
        },
        { text: 'Created At', value: 'created_at',sortable: true, align: 'center'},
        {
          text: "Insurance Type",
          align: "left",
          sortable: false,
          value: "insurance_type"
        },
        {
          text: "Beneficiary",
          align: "center",
          sortable: false,
          value: "fullName"
        },
        {
          text: "Passport No",
          align: "center",
          sortable: false,
          value: "passport"
        },
        {
          text: "Country Residence",
          align: "center",
          sortable: false,
          value: "country_residence"
        },
        {
          text: "Country Destination",
          align: "center",
          sortable: false,
          value: "country_destination"
        },
        {
          text: "From",
          align: "center",
          sortable: false,
          value: "duration_from"
        },
        {
          text: "To",
          align: "center",
          sortable: false,
          value: "duration_to"
        },
        { 
          text: 'Cancelled', 
          sortable: false, 
          align: 'cancelled', 
          value: 'canceled',
        }
      ],
      items: []
    };
  },
  filters: {
    booleanify: function(value) {
        if (value == '0') {
          value = "No";
        } else {
          value = "Yes";
        }
        return value;
      },
     removeTime: function (value) {
        return value.substring(0, value.length-9);
    }
  },
  methods: {
    showPolicy(item) {
      this.$router.push({ path: `/agency/issued_policies/show/${item.uuid}` });
    },
    buildQuery() {
        let str = '?';
        if (this.dateFrom) {
          str+= 'date_from=' + this.dateFrom + "&";
        }
        if (this.dateTo) {
          str+= 'date_to=' + this.dateTo + "&";
        }
        str = str.slice(0, -1);
        this.searchQuery = str;
      },
    getPolicies() {
      this.loading = true;
      this.buildQuery();
      axios.get("/policies" + this.searchQuery).then(response => {
        this.loading = false
        this.items = response.data.policies;
        this.items.forEach((element, index) => {
          element.people.forEach((person, ind) => {
            this.items[index]['fullName' + ind] = person.first_name + ' ' + person.middle_name + ' ' + person.last_name;
            this.items[index]['passport' + ind] = person.passport_number;
          });
        });
        this.pagination.descending = true
      });
    }
  },
  created() {
    this.getPolicies();
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/agency/Policy/Issued/Issued.vue